export default __webpack_public_path__ + "cbb8d83522bd1b2d06a48b5e45f30346.ttf";